import { createSlice } from '@reduxjs/toolkit'
import { Tab, Tabs } from './constants'

const initialState: {
  tab: Tab
} = {
  tab: Tabs.Chats
}

const navTab = createSlice({
  name: 'navTabs',
  initialState,
  reducers: {
    setTab(state, { payload }: { payload: Tab }) {
      state.tab = payload
    }
  }
})

export const { setTab } = navTab.actions
export default navTab.reducer
